import { getUserLocationData } from '../../../../../lib/common/userLocation';
import { FC, useEffect, useState } from 'react';
import tw from 'twin.macro';
import { mandatoryCheckBox } from '../../InputPatterns';
import { InputProps } from './interface';
import { UserLocation } from '../../../../../interfaces/city';

const Container = tw.div`relative w-full`;

const Checkbox = tw.input`cursor-pointer`;

const Label = tw.label`
    inline-block pl-6 leading-4 text-xs text-[#666] cursor-pointer 
`;

const Anchor = tw.a`text-[#586FEB]`;

const Description = tw.p`block   `;

const WhatsappUpdatesCheckbox: FC<InputProps> = ({ register, isRightSideStickyForm, isWhatsappContent = false }) => {
  const [userCurrentLocation, setUserCurrentLocation] = useState<UserLocation>();

  useEffect(() => {
    async function getUserLocationDetails() {
      let response = await getUserLocationData();
      setUserCurrentLocation(response);
    }
    // getCountriesList
    getUserLocationDetails();
  }, []);

  const id = Math.random();
  return (
    <>
      {userCurrentLocation && userCurrentLocation?.region?.id != 3 && (
        <Container className={`group ${isRightSideStickyForm && 'top-[-10px]'}`}>
          {/* Label & input */}
          <Label htmlFor={`whatsapp-checkbox-${id}`}>
            <Checkbox
              id={`whatsapp-checkbox-${id}`}
              type="checkbox"
              className={`${isWhatsappContent ? 'form-checkbox-small-master' : 'form-checkbox-small'}`}
              {...register('whatsapp_subscription_status')}
              hidden
              defaultChecked
            />
            <span className="absolute left-0"></span>
            <span className={`${isWhatsappContent ? 'text-sm leading-[21px]' : ''}`}>
              {isWhatsappContent
                ? 'I want to receive updates directly on WhatsApp'
                : 'I want to receive updates directly on WhatsApp'}
            </span>
          </Label>

          <Description className={` md:pt-5 pt-[27px] md:text-sm leading-[21px] text-[#666666] md:text-[#333333]`}>
            By tapping submit, you agree to upGrad{' '}
            <Anchor className=" text-[#586feb]" href="https://www.upgrad.com/privacy" target="_blank">
              Privacy Policy
            </Anchor>{' '}
            and{' '}
            <Anchor className=" text-[#586feb]" href="https://www.upgrad.com/terms" target="_blank">
              Terms & Conditions
            </Anchor>
          </Description>
        </Container>
      )}
    </>
  );
};

export default WhatsappUpdatesCheckbox;
